import { Loader } from "lucide-react";
import { FC } from "react";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useDeleteImageMutation } from "@/data/mutations";
import { Image } from "@/data/types";
import { useDialogState } from "@/hooks/use-dialog-state";

export const DeleteImageDialog: FC<Image> = (image) => {
  const { dialog, closeDialog } = useDialogState();
  const deleteImageMutation = useDeleteImageMutation();

  const handleSubmit = () => {
    deleteImageMutation.mutate(image.id);
  };

  return (
    <AlertDialog open={dialog?.name === "delete-image"}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Image {image.file_name}</AlertDialogTitle>
          <AlertDialogDescription>
            Image {image.file_name} will be deleted. This action is
            irreversible.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button
            variant="outline"
            onClick={closeDialog}
            disabled={deleteImageMutation.isPending}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleSubmit}
            disabled={deleteImageMutation.isPending}
          >
            {deleteImageMutation.isPending ? (
              <Loader className="animate-spin" />
            ) : null}
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
